import { EnrollmentStatus } from "../types/client-education-detail.types";
import type { EnrollmentDto } from "../types/client-education-detail.types";

export type AccessMode =
  | "catalog"
  | "pending"
  | "rejected"
  | "cancelled"
  | "trainee"
  | "completing"
  | "notCompleted";

export function resolveAccessMode(enrollment: EnrollmentDto | null | undefined): AccessMode {
  if (!enrollment) return "catalog";
  switch (enrollment.status) {
    case EnrollmentStatus.REQUESTED:
    case EnrollmentStatus.APPROVED_BRANCH_MANAGER:
      return "pending";
    case EnrollmentStatus.REJECTED_BY_BRANCH_MANAGER:
    case EnrollmentStatus.REJECTED_BY_CENTRAL_MANAGER:
      return "rejected";
    case EnrollmentStatus.CANCELLED:
      return "cancelled";
    case EnrollmentStatus.ENROLLED:
      return "trainee";
    case EnrollmentStatus.NOT_COMPLETED:
      return "notCompleted";
    case EnrollmentStatus.CONTENT_COMPLETED:
    case EnrollmentStatus.EXAM_FAILED:
    case EnrollmentStatus.EXAM_COMPLETED:
    case EnrollmentStatus.COMPLETED:
    case EnrollmentStatus.EXAM_STARTED:
    case EnrollmentStatus.SURVEY_STARTED:
      return "completing";
    default:
      return "catalog";
  }
}
